import { PublishCourse } from "../publishCourse"

export const PublishSales = ({ publish, pageSwap }) => {
    return(
        <PublishCourse
            pageSwap={pageSwap}
            customerStage={1}
        />

    )
}